// evertel
import { injectable, inject, decorate } from '@evertel/di'
import { Api } from '@evertel/api'
import { APIDataMedia, APIDataObject, SchemaProps } from '@evertel/types'


class SchemaMediaUtils {
    constructor(
        private api: Api
    ) {
    }

    /**
     * Processes media files in schema fields, uploading any File objects and replacing them with media IDs.
     * NOTE: This mutates the original schema object in place.
     */
    processSchemaMedia = async (schemaId: number, schema: SchemaProps) => {
        // process root-level fields
        if (schema.fields) {
            await this.processFields(schemaId, schema.fields)
        }

        // process internalSchemas (subforms) fields
        if (schema.internalSchemas) {
            for (const internalSchema of Object.values(schema.internalSchemas)) {
                if (internalSchema.fields) {
                    await this.processFields(schemaId, internalSchema.fields)
                }
            }
        }
    }

    private processFields = async (schemaId: number, fields: Record<string, any>) => {
        for (const field of Object.values(fields)) {
            if (field.type === 'checkbox' || field.type === 'checkbox-group') {
                // loop through options and find any images that need uploading
                for (const option of field.options) {
                    if (option.image instanceof File) {
                        const media = await this.uploadMedia(option.image, schemaId)
                        option.image = media?.id
                    }
                }
            }
        }
    }

    uploadMedia = async (file: File, schemaId: number, meta?: APIDataObject): Promise<APIDataMedia|undefined> => {
        if (!file) return undefined

        const formData = new FormData()
        formData.append('file', file)

        // upload media
        return await this.api.Routes.DocumentSchema.postMediaUpload(
            schemaId,
            formData,
            meta
        )
    }
}

decorate(injectable(), SchemaMediaUtils)
decorate(inject(Api), SchemaMediaUtils, 0)

export { SchemaMediaUtils }
